import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type DiscardReason,
  type ReferralDetail,
} from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const updateReferralStatus = createAsyncThunk<
  ReferralDetail,
  {
    referralId: string;
    status: "contacted" | "discarded";
    reason?: DiscardReason;
  },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(
  thunkTypes.UPDATE_REFERRAL_STATUS,
  async ({ referralId, status, reason }, { extra }) => {
    return await extra.referralsBackofficeRepo.updateStatus(
      referralId,
      status,
      reason,
    );
  },
);
